import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46b371ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "achieved-goal-container" }
const _hoisted_3 = { class: "goal-content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "reward" }
const _hoisted_7 = { class: "reward-title" }
const _hoisted_8 = { class: "reward-bonus" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.achievedGoal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.achievedGoal.title), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.achievedGoal.description), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.achievedGoal.reward.title), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.achievedGoal.reward.bonus), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.achievedGoal.icon), 1)
        ]),
        _hoisted_10
      ]))
    : _createCommentVNode("", true)
}